"use client";
/** Tells the server the browser's timezone (cookie `habits-tz`) so every "today" is the person's local day. */
import { useEffect } from "react";

export function TimezoneCookie() {
  useEffect(() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!tz) return;
      const current = document.cookie.match(/(?:^|; )habits-tz=([^;]*)/)?.[1];
      if (current !== encodeURIComponent(tz)) document.cookie = `habits-tz=${encodeURIComponent(tz)}; path=/; max-age=31536000; samesite=lax`;
    } catch { /* no Intl / cookies blocked */ }
  }, []);
  return null;
}
